<template>
    <div v-for="(item, index) in listOrderEsim" :key="index" class="mb-3">
        <div class="bg-white rounded-3 p-3 mb-3" @click="handleGoToDetail(item)">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="d-flex justify-content-center align-items-center gap-3">
                    <img src="@/static/icon_esim.png" width="21" alt="esim">
                    <p class="mb-0 font-size-14">{{ item.phone }}</p>
                </div>
                <div class="d-flex justify-content-center align-items-center gap-2">
                    <p class="mb-0 status font-size-14" v-if="item.status == 1">{{ $t('esim_status_fail') }}</p>
                    <p class="mb-0 status font-size-14" v-if="item.status == 2">{{ $t('esim_status_waiting') }}</p>
                    <p class="mb-0 status font-size-14" v-if="item.status == 3">{{ $t('esim_status_success') }}</p>
                    <p class="mb-0 status font-size-14" v-if="item.status == 4">{{ $t('esim_status_expired') }}</p>
                    <p class="mb-0" :class="{
                        'bage-failed': item.status == 1,
                        'bage-waiting': item.status == 2,
                        'bage-success': item.status == 3,
                        'bage-expired': item.status == 4
                    }"></p>
                </div>
            </div>
            <van-row>
                <van-col span="7">
                    <p class="mb-0 font-size-12">{{ $t('esim_order_code') }}</p>
                    <p class="mb-0 font-size-12">{{ item.orderCode }}</p>
                </van-col>
                <van-col span="9">
                    <p class="mb-0 font-size-12">{{ $t('esim_ordered_date') }}</p>
                    <p class="mb-0 font-size-12">{{ formatDateToHHMMDDMMYYYY(item.orderDate) }}</p>
                </van-col>
                <van-col span="8">
                    <div v-if="item.status == 2 || item.status == 4">
                        <p class="mb-0 font-size-12">{{ $t('esim_expired_time') }}</p>
                        <p class="mb-0 font-size-12">{{ formatDateToHHMMDDMMYYYY(item.expiredTime) }}</p>
                    </div>
                    <div v-if="item.status == 3">
                        <div class="d-flex justify-content-end align-items-center w-100">
                            <van-button size="small" type="default"
                                class="btn btn-yellow btn-show-qr-code border-0 text-primary rounded-3"
                                @click="handleGoToDetail(item)">
                                <span class="font-size-12 text-white">{{ $t('esim_show_qr_code') }}</span>
                            </van-button>
                        </div>
                    </div>
                </van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
import { Row, Col } from 'vant';
import {
    formatDateToHHMMDDMMYYYY
} from "@/ultis/dateFormat";
export default {
    components: {
        [Row.name]: Row,
        [Col.name]: Col,
    },
    props: {
        listOrderEsim: {
            type: Array,
            required: true
        }
    },
    methods: {
        formatDateToHHMMDDMMYYYY,
        handleGoToDetail(item) {
            this.$emit('handleGoToDetail', item)
        }
    }
}
</script>
<style>
.bage-success {
    background-color: #44CA83;
    width: 10px;
    height: 10px;
    border-radius: 5px;
}

.bage-failed {
    background-color: #C41627;
    width: 10px;
    height: 10px;
    border-radius: 5px;
}

.bage-expired {
    background-color: #FF0000;
    width: 10px;
    height: 10px;
    border-radius: 5px;
}

.bage-waiting {
    background-color: #3E7BFA;
    width: 10px;
    height: 10px;
    padding: 5px;
    border-radius: 5px;
}

.van-picker-column__wrapper {
    padding-left: 0;
}

.btn-show-qr-code {
    padding: 5px !important;
}
</style>